module.exports = __webpack_public_path__ + "img/default.0229c263.png";